import { render, staticRenderFns } from "./QuestionTemplateEditForm.vue?vue&type=template&id=0df60cfe&scoped=true&"
import script from "./QuestionTemplateEditForm.vue?vue&type=script&lang=ts&"
export * from "./QuestionTemplateEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionTemplateEditForm.vue?vue&type=style&index=0&id=0df60cfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df60cfe",
  null
  
)

export default component.exports